/* Reversible drawer motion. Keep layers mounted through their exit animation. */
(function () {
  'use strict';
  var motions = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function cancel(root) {
    var current = motions.get(root);
    if (!current) return;
    motions.delete(root);
    current.animations.forEach(function (animation) { animation.onfinish = null; animation.cancel(); });
    current.resolve(false);
  }
  function animate(options, opening) {
    var root = options.root, panel = options.panel || root, backdrop = options.backdrop;
    var prior = motions.get(root), visible = root.classList.contains('is-open');
    if (prior && prior.opening === opening && !options.immediate) return prior.promise;
    if (opening && visible && !prior) return Promise.resolve(true);
    var start = visible ? getComputedStyle(panel).transform : 'translateX(' + (options.side === 'left' ? '-100%' : '100%') + ')';
    var opacity = visible && backdrop ? getComputedStyle(backdrop).opacity : '0';
    cancel(root);
    var resolve;
    var promise = new Promise(function (done) { resolve = done; });
    function finish() {
      motions.delete(root);
      root.classList.toggle('is-open', opening);
      root.dataset.drawerState = opening ? 'open' : 'closed';
      root.inert = !opening;
      root.setAttribute('aria-hidden', String(!opening));
      if (backdrop) backdrop.classList.toggle('is-open', opening);
      record.animations.forEach(function (animation) { animation.onfinish = null; animation.cancel(); });
      if (!opening && options.onClosed) options.onClosed();
      resolve(true);
    }
    var record = {opening:opening, promise:promise, resolve:resolve, animations:[], finish:finish};
    motions.set(root, record);
    if (opening) {
      root.classList.add('is-open'); root.inert = false; root.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
    }
    if (options.immediate || reduced.matches || document.body.dataset.animations === 'false' || !panel.animate || (!visible && !opening)) { finish(); return promise; }
    root.dataset.drawerState = opening ? 'opening' : 'closing';
    var settings = {duration:opening ? 300 : 220, easing:opening ? 'cubic-bezier(.22,1,.36,1)' : 'cubic-bezier(.4,0,1,1)', fill:'both'};
    var movement = panel.animate([{transform:start === 'none' ? 'translateX(0)' : start},{transform:opening ? 'translateX(0)' : 'translateX(' + (options.side === 'left' ? '-100%' : '100%') + ')'}], settings);
    record.animations.push(movement);
    if (backdrop) record.animations.push(backdrop.animate([{opacity:opacity},{opacity:opening ? 1 : 0}], settings));
    movement.onfinish = finish;
    return promise;
  }
  window.AinazDrawerMotion = {
    open:function (options) { return animate(options, true); },
    close:function (options) { return animate(options, false); }
  };
  if (reduced.addEventListener) reduced.addEventListener('change', function () {
    if (reduced.matches) Array.from(motions.values()).forEach(function (record) { record.finish(); });
  });
})();
